import * as React from 'react';
import { Alert, FormGroup } from 'reactstrap';
import { Select } from '../../../components/ui/Select';
import { GetAllSurveys, ISurvey } from './utils';

interface ISurveySelectProps {
  value: string
  onChange: (newValue: string) => void
  projectId?: string
  label?: string
  required?: boolean
  readOnly?: boolean
}

interface ISurveySelectState {
  surveys: ISurvey[]
  isEmpty: boolean
}

export class SurveySelect extends React.Component<ISurveySelectProps, ISurveySelectState> {
  state: ISurveySelectState = {
    surveys: [],
    isEmpty: false,
  }

  lastProjectId = ''

  componentWillMount() {
    this.loadSurveysIfNeeded()
  }

  componentWillReceiveProps(props: ISurveySelectProps) {
    this.loadSurveysIfNeeded(props)
  }

  loadSurveysIfNeeded(props = this.props) {
    const { value, projectId } = props

    if (this.lastProjectId !== projectId) {
      this.setState({ surveys: [] })

      if (projectId) {
        GetAllSurveys(projectId).then((surveys) => {
          const isEmpty = surveys.length <= 0

          this.setState({ surveys, isEmpty })
        })
      } else if (value !== undefined) {
        this.props.onChange(undefined)
      }

      this.lastProjectId = projectId
    }
  }

  render() {
    const { value, onChange, required, readOnly, label = 'Survey', projectId } = this.props
    const { surveys, isEmpty } = this.state

    return (
      <FormGroup>
        <label>{label}</label>

        {isEmpty &&
          <Alert color="info">
            <i className="fas fa-fw fa-info-circle" />
            <span>&nbsp;No surveys found; select another project.</span>
          </Alert>
        }

        <Select<ISurvey, 'abbr'>
          label={label}
          options={surveys}
          value={value}
          readOnly={readOnly}
          required={required}
          loading={surveys.length <= 0}
          valueKey="abbr"
          labelKey="label"
          loadingText={!projectId ? 'Select a project above' : undefined}
          onChange={(newValue) => onChange(newValue)} />
      </FormGroup>
    )
  }
}
